// import { mapGetters } from "vuex";
// import { mapGetters } from "vuex";

export default {
  data() {
    return {
      // eslint-disable-next-line
      // eslint-disable-next-line
      partsQAOptions: [
        "Standard",
        "Certificate",
        "Review"
      ],
      // eslint-disable-next-line
      partsDeliveryOrginOptions: [
        "Local",
        "State",
        "National",
        "Overseas"
      ],
      // eslint-disable-next-line
      partsSourceOptions: [
        "Reuse",
        "Site",
        "Workshop",
        "Warehouse",
        "External"
      ],
      // eslint-disable-next-line
      partsTypeOptions: [
        "Matl",
        "Part",
        "Hire",
        "Tool"
      ],
      // eslint-disable-next-line
      partsUnitOptions: [
        "unit",
        "pkg",
        "skid",
        "drum"
      ],
      // eslint-disable-next-line
      partsStatusOptions: [
        "Ready",
        "Progress",
        "Issue"
      ],
      // eslint-disable-next-line
      partsUnitsOptions: [
        "Reuse",
        "Site",
        "Workshop",
        "Warehouse",
        "Order"
      ]
    };
  }
};
